module.exports = __webpack_public_path__ + "static/fonts/Spoqa-Han-Sans-Thin.a1a1697.woff";